import Api from "./Api";

export const BookingService = {

    getUserBookingsByVenue: async (venueId) => {

        const res = await Api.get(
            `/user-bookings?filters[eventVenue][id][$eq]=${venueId}&filters[paymentStatus][$eq]=Success&populate[eventVenue][populate]=event`
        );

        return res.data;

    }

};